interface FieldErrorMessageProps {
    /** Already translated; nothing is rendered without one. */
    message?: string;
}

export const FieldErrorMessage = ({ message }: FieldErrorMessageProps) =>
    message ? (
        <p
            role={'alert'}
            className={'text-error text-sm'}
        >
            {message}
        </p>
    ) : null;
